import { Node } from "@tiptap/core";

export const TextField = Node.create({
  name: "textField",

  inline: true,
  group: "inline",
  atom: false,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      label: { default: "" },
      type: { default: "text" },
      value: { default: "" },
    };
  },

  parseHTML() {
    return [{ tag: "text-field" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["text-field", HTMLAttributes];
  },

  addNodeView() {
    return ({ node, editor, getPos, updateAttributes }) => {
      const input = document.createElement("input");

      input.value = node.attrs.value || "";
      input.placeholder = node.attrs.label;
      input.type = node.attrs.type || "text";

      input.className = [
        "inline-block align-middle my-0.5",
        "min-w-[120px] max-w-[240px]",
        "rounded-lg border border-[#375AE7]/20 bg-[#F5F7FE]",
        "px-3 py-1.5 text-sm font-medium text-slate-700",
        "placeholder:text-slate-400 placeholder:font-normal",
        "shadow-sm outline-none transition-all",
        "focus:border-[#375AE7]/50 focus:bg-white focus:ring-2 focus:ring-[#375AE7]/15",
      ].join(" ");

      input.addEventListener("keydown", (e) => {
        if (e.key === "Backspace" && input.value === "") {
          const pos = getPos();

          editor
            .chain()
            .focus()
            .deleteRange({ from: pos, to: pos + 1 })
            .run();

          e.preventDefault();
        }
      });

      input.addEventListener("input", (e) => {
        updateAttributes({ value: e.target.value });
      });

      return { dom: input };
    };
  },
});
